// Регистрация панелей раздела «Люди» в каркасе. Побочный эффект при загрузке модуля: раздел
// объявляет, что умеет рисовать в стопке панелей, а каркас (PanelStack) остаётся без знания о
// разделах. Импортируется из PeopleSection — то есть ровно тогда, когда раздел попадает в
// сборку экрана.

import { registerPanel } from '@/layout/panel-registry';

import {
  PANEL_ASSIGN,
  PANEL_CLOSE,
  PANEL_DOCUMENT,
  PANEL_EDIT_EMPLOYEE,
  PANEL_EXTEND,
  PANEL_INVITE,
  PANEL_NEW_EMPLOYEE,
  PANEL_PAYOUT,
  PANEL_RATE,
  PANEL_STAFF_POST,
  PANEL_STATUS,
  PANEL_TRANSFER,
} from '../route';

import { AssignPanel } from './AssignPanel';
import { CloseAssignmentPanel } from './CloseAssignmentPanel';
import { DocumentPanel } from './DocumentPanel';
import { EditEmployeePanel } from './EditEmployeePanel';
import { ExtendAssignmentPanel } from './ExtendAssignmentPanel';
import { InvitePanel } from './InvitePanel';
import { PayoutPanel } from './PayoutPanel';
import { NewEmployeePanel } from './NewEmployeePanel';
import { RateChangePanel } from './RateChangePanel';
import { StaffPostPanel } from './StaffPostPanel';
import { StatusPanel } from './StatusPanel';
import { TransferPanel } from './TransferPanel';

registerPanel(PANEL_NEW_EMPLOYEE, {
  title: () => 'Новый сотрудник',
  render: ({ onClose }) => <NewEmployeePanel onClose={onClose} />,
});

registerPanel(PANEL_EDIT_EMPLOYEE, {
  title: () => 'Правка карточки',
  render: ({ id, onClose }) => <EditEmployeePanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_INVITE, {
  title: () => 'Пригласить выбранных',
  render: ({ onClose }) => <InvitePanel onClose={onClose} />,
});

registerPanel(PANEL_STATUS, {
  title: () => 'Смена статуса',
  render: ({ id, onClose }) => <StatusPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_DOCUMENT, {
  title: () => 'Новый документ',
  render: ({ id, onClose }) => <DocumentPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_PAYOUT, {
  title: () => 'Новое заявление о реквизитах',
  render: ({ id, onClose }) => <PayoutPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_ASSIGN, {
  title: () => 'Постановка на объект',
  render: ({ id, onClose }) => <AssignPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_TRANSFER, {
  title: () => 'Перевод на другой объект',
  render: ({ id, onClose }) => <TransferPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_CLOSE, {
  title: () => 'Закрытие назначения',
  render: ({ id, onClose }) => <CloseAssignmentPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_EXTEND, {
  title: () => 'Продление назначения',
  render: ({ id, onClose }) => <ExtendAssignmentPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_RATE, {
  title: () => 'Изменение тарифа',
  render: ({ id, onClose }) => <RateChangePanel id={id} onClose={onClose} />,
});

// Тот же мастер, что и в карточке объекта, под тем же именем. Регистрируют оба раздела,
// потому что регистрация — побочный эффект загрузки модуля РАЗДЕЛА: человек, открывший мастер
// из реестра людей, кода раздела «Объекты» в сборке экрана не имеет вовсе.
registerPanel(PANEL_STAFF_POST, {
  title: () => 'Поставить людей на пост',
  render: ({ id, onClose }) => <StaffPostPanel id={id} onClose={onClose} />,
});
